import { ThemeDefinition } from 'vuetify';

export type TThemes = {
  light: ThemeDefinition;
  dark?: ThemeDefinition;
};

export const baseThemes: TThemes = {
  light: {
    dark: false,
    colors: {
      background: '#f8f8f8',

      // Key Color
      brand: '#00AF98',
      primary: '#02a4ff',
      secondary: '#41bb46',

      // TODO: 自動生成にバグあり手動で割当
      'accentBg-darken-2': '#191919',
      'accentBg-darken-1': '#393939',
      accentBg: '#575757',
      'accentBg-lighten-1': '#6a6a6a',
      'accentBg-lighten-2': '#929292',
      'accentBg-lighten-3': '#b3b3b3',
      'accentBg-lighten-4': '#d7d7d7',
      'accentBg-lighten-5': '#e7e7e7',
      'accentBg-lighten-6': '#f1f1f1',
      'accentBg-lighten-7': '#f8f8f8',

      subText: '#999',

      // border
      border: '#d7d7d7',

      // Status Color
      success: '#449851',
      warning: '#e0ab44',
      info: '#4d88cd',
      error: '#f44848',
      terminated: '#999',
    },
  },
};
